/**
 * Hideable alert-table columns (column show/hide).
 *
 * Single source of truth for which alert-table columns the user can toggle. The
 * `id`s MUST match the `isHidden(id)` gates + hide buttons in AlertTableView. The
 * Alert (name) and Actions columns are intentionally PINNED — not listed here, so
 * they can never be hidden. The shared show/hide primitives live in
 * ../shared/columnVisibility.
 */
import type { HideableColumn } from "../shared/columnVisibility";

export const ALERT_HIDEABLE_COLUMNS: HideableColumn[] = [
  { id: "status", label: "Status" },
  { id: "condition", label: "Condition" },
  { id: "client", label: "Client" },
  { id: "platform", label: "Platform" },
  { id: "interval", label: "Interval" },
  { id: "lastTriggered", label: "Last triggered" },
];
